import {REQUEST_CALCULATED_ORDER_SUCCESS} from "../../../constant/transaction/CalculatedOrderConstant";

const initialState = {
    calculatedOrder: {
        data: [],
    },
};


export const calculatedOrderReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_CALCULATED_ORDER_SUCCESS:
            return {
                ...state,
                calculatedOrder: {
                    data: payload,
                },
            };
        default:
            return state;
    }
}
